import { render, staticRenderFns } from "./UpdatePersonalDataRegister.vue?vue&type=template&id=a1843af0&scoped=true&"
import script from "./UpdatePersonalDataRegister.vue?vue&type=script&lang=js&"
export * from "./UpdatePersonalDataRegister.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePersonalDataRegister.vue?vue&type=style&index=0&id=a1843af0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1843af0",
  null
  
)

export default component.exports